<nav class="navbar bg-forth h-10">
  <span class="text-clear mb-0 h6" *ngIf="utilisateurConnecte">{{ utilisateurConnecte.nom }}  {{ utilisateurConnecte.prenom }}, connecté en tant que scolarité</span>

  <ul class="nav navbar-nav ml-auto">
      <a class="nav-link text-white pointeur" (click)="signOut()"><i class="fa fa-power-off mr-3"></i>Deconnexion</a>
  </ul>
</nav>

